// removed by extract-text-webpack-plugin
module.exports = {"SocialIconsContainerBlock":"SocialIconsContainerBlock","SocialIconsContainerBlock__container":"SocialIconsContainerBlock__container","SocialIconsContainerBlock__list-ul":"SocialIconsContainerBlock__list-ul","SocialIconsContainerBlock__link":"SocialIconsContainerBlock__link","SocialIconsContainerBlock__box":"SocialIconsContainerBlock__box","SocialIconsContainerBlock__text":"SocialIconsContainerBlock__text","SocialIconsContainerBlock__image":"SocialIconsContainerBlock__image"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/social-icons-container-block/styles.css
// module id = 692
// module chunks = 0 1